import { useVisibility } from "./use-visibility";
export var useDataViz = function useDataViz() {
  return useVisibility('isDataVizVisibile');
};